module.exports = __webpack_public_path__ + "static/media/sm1.74fcd52b.jpg";